<template>
  <div>
    <gg-loading :loading="promoLoaded" type="article">
      <v-stepper v-if="promo.active" v-model="currentStep" vertical>
        <promo-step-one :step="currentStep" @service-selected="serviceSelected" />
        <promo-step-two :step="currentStep" :service="selectedService" @promo-submitted="promoSubmitted" />
        <promo-step-three :step="currentStep" :promo-request-id="promoRequestId" />
      </v-stepper>
      <v-card class="app-card" v-else>
        <v-card-text>
          <h2>Promotion Expired</h2>
          <p>This promotion has expired. Please contact us if you have any questions.</p>
        </v-card-text>
      </v-card>
    </gg-loading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PromoStepOne from './PromoStepOne'
import PromoStepTwo from './PromoStepTwo'
import PromoStepThree from './PromoStepThree'
import { isEmpty } from 'Helpers/helpers'

export default {
  name: 'Promo',
  components: {
    PromoStepOne,
    PromoStepTwo,
    PromoStepThree,
  },
  data: () => ({
    currentStep: 1,
    selectedService: {},
    promoRequestId: 0,
  }),
  computed: {
    ...mapGetters(['promo']),
    promoLoaded () {
      return isEmpty(this.promo)
    }
  },
  methods: {
    serviceSelected (service) {
      this.selectedService = service
      this.currentStep++
    },
    promoSubmitted (payload) {
      this.promoRequestId = payload.promo_request_id
      this.currentStep++
    },
  }
}
</script>
